import { TApplicationState } from '../../types/redux';
import { getFirstBuilder } from '../newbuilding';

export const getBuilderChatDefaultMessage = (state: TApplicationState): string | undefined => {
  const builder = getFirstBuilder(state);

  return builder?.chat?.defaultMessage;
};
